<template>
  <div style="align-self: center;">
    <el-table id="patient-history-table" class="table" :data="list">
      <el-table-column prop="code" label="การจอง" width="90" />
      <el-table-column prop="date" label="วันเริ่ม-จบงาน" width="250" />
      <el-table-column prop="package" label="แพ็กเกจ" width="250" />
      <el-table-column prop="cg_id" label="เลขผู้ดูแล" width="90" >
        <template slot-scope="scope">
          <div class="cg-item" v-for="(cg, index) in scope.row.caregivers" :key="'id' + index">
            <span>{{cg.id}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="label" label="ชื่อผู้ดูแล" width="200" >
        <template slot-scope="scope">
          <div class="cg-item" v-for="(cg, index) in scope.row.caregivers" :key="'name' + index">
            <span>{{cg.name}}</span>
            <el-tooltip class="item" effect="light" content="" placement="right-start">
              <div style="font-family: 'Sukhumvit'; line-height: 22px;" slot="content"><div style="font-family: 'Sukhumvit-Bold'; margin-bottom: 4px;">{{cg.reasonTitle}}</div>{{cg.reasonDetail}}</div>
              <img class="img-24" v-if="cg.reasonTitle === 'สาเหตุที่ผู้ดูแลออกจากเคส'" src="https://storage.healthathome.in.th/f86f95e7-e813-4a8c-bd5e-c53fc1dac304.svg" />
              <img class="img-24" v-if="cg.reasonTitle === 'สาเหตุที่ลูกค้าไม่ใช้บริการคนนี้ต่อ'" src="https://storage.healthathome.in.th/ab2609eb-8d6b-459b-966b-7dd7bf91bd34.svg" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="label" label="สถานะ" width="270">
        <template slot-scope="scope">
          <div class="status-container">
            <div class="status-item usage">{{ scope.row.statuses[0] }}</div>
            <button class="status-item contract" @click="changeContractHandler(scope.row)">
              <div class="text">{{ scope.row.statuses[1] }}</div>
              <div class="edit-logo">
                <img src="https://storage.healthathome.in.th/66085de2-c806-45ae-aad3-1b90f6048edc.svg" />
              </div>
            </button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="label" label="เหตุผล" width="250">
        <template slot-scope="scope">
          <span>{{scope.row.reason}}</span>
        </template>
      </el-table-column>
      <el-table-column label="." width="50">
        <template slot-scope="scope">
          <div class="click-row-button" @click="rowClick(scope.row)">
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- Do You Want to Change Contract Status Dialog -->
    <el-dialog :visible.sync="control.showConfirmChangeDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="dialog-header-18" style="margin-left: 17px; font-family: 'Sukhumvit-Medium';">คุณต้องการเปลี่ยนสถานะ ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleConfirmChange(false)">ไม่</el-button>
        <el-button type="primary" @click="handleConfirmChange(true)" class="edit">ยืนยัน</el-button>
      </span>
    </el-dialog>

    <!-- Select Contract Status Dialog -->
    <el-dialog :visible.sync="control.showSelectStatusDialog" :showClose="false" :closeOnClickModal="false" style="font-family: 'Sukhumvit';" width="35%">
      <div class="dialog-header-18" style="margin-bottom: 8px; font-family: 'Sukhumvit-Bold';">สถานะ</div>
      <el-select v-model="form.subscribe" placeholder="เลือกสถานะ" @change="changeStatus()" style="margin: 0 0 32px 0; max-width: 60%;">
        <el-option key="None" label="-" :value="0"></el-option>
        <el-option key="Subscription" label="ต่อสัญญา" :value="1"></el-option>
        <el-option key="NonSubscription" label="ไม่ต่อสัญญา" :value="2"></el-option>
      </el-select>
      <div v-if="form.subscribe === 2">
        <div class="dialog-header-18" style="margin-bottom: 8px; font-family: 'Sukhumvit-Bold';">สาเหตุที่ไม่ต่อสัญญา</div>
        <p style="margin-bottom: 0px;"><el-radio label="bad" style="font-size: 18px;" v-model="form.reason.type" @change="changeReasonType()">Bad Ending</el-radio></p>
        <div v-if="form.reason.type === 'bad'">
          <div style="margin-left: 25px; display: flex; align-items: baseline;">
            <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">ที่มา </span>
            <el-select v-model="form.reason.from" placeholder="เลือกที่มา" @change="changeReasonFrom()" style="margin: 0 24px 14px 0; max-width: 100px; min-width: 100px;">
              <template slot="empty">
                <span>abc</span>
              </template>
              <el-option key="Customer" label="ลูกค้า" value="ลูกค้า"></el-option>
              <el-option key="Carepro" label="ผู้ดูแล" value="ผู้ดูแล"></el-option>
            </el-select>
            <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">สาเหตุ </span>
            <el-select v-if="form.reason.from !== 'ผู้ดูแล'" v-model="form.reason.reason" placeholder="เลือกสาเหตุ" style="margin: 0 0 14px 0; width: 100%;">
              <el-option key="GetCareproFromOther" label="ได้คนจากที่อื่น" value="ได้คนจากที่อื่น"></el-option>
              <el-option key="DirectHire" label="จ้างตรง" value="จ้างตรง"></el-option>
              <el-option key="NoSkill" label="ไม่มีผู้ดูแลคุณสมบัติที่ต้องการ" value="ไม่มีผู้ดูแลคุณสมบัติที่ต้องการ"></el-option>
              <el-option key="WaitCaregiverHAH" label="รอผู้ดูแลจาก HAH คนเดิม" value="รอผู้ดูแลจาก HAH คนเดิม"></el-option>
              <el-option key="Expensive" label="ราคาแพง / ไม่มีส่วนลด" value="ราคาแพง / ไม่มีส่วนลด"></el-option>
              <el-option key="WantCancelCreditCard" label="ต้องการยกเลิกตัดบัตรเครดิต" value="ต้องการยกเลิกตัดบัตรเครดิต"></el-option>
              <el-option key="DontUnderstand" label="ไม่เข้าใจเงื่อนไขการให้บริการ" value="ไม่เข้าใจเงื่อนไขการให้บริการ"></el-option>
              <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
            </el-select>
            <el-select v-if="form.reason.from === 'ผู้ดูแล'" v-model="form.reason.reason" placeholder="เลือกสาเหตุ" style="margin: 0 0 14px 0;">
              <el-option key="NoCG" label="ไม่มีผู้ดูแลแทนงาน" value="ไม่มีผู้ดูแลแทนงาน"></el-option>
              <el-option key="NoContractCG" label="ไม่มีผู้ดูแลต่อสัญญา" value="ไม่มีผู้ดูแลต่อสัญญา"></el-option>
              <el-option key="Covid" label="ผู้ดูแลตรวจพบโควิด" value="ผู้ดูแลตรวจพบโควิด"></el-option>
              <el-option key="NoSkill" label="ปัญหาทักษะ ความชำนาญ" value="ปัญหาทักษะ ความชำนาญ"></el-option>
              <el-option key="NoSoftSkill" label="ปัญหา Soft skill" value="ปัญหา Soft skill"></el-option>
              <el-option key="NotSatisfied" label="ลูกค้าไม่พอใจการทำงาน" value="ลูกค้าไม่พอใจการทำงาน"></el-option>
              <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
            </el-select>
          </div>
        </div>

        <p style="margin-bottom: 0px;"><el-radio label="good" style="font-size: 18px;" v-model="form.reason.type" @change="changeReasonType()">Good Ending</el-radio></p>
        <div v-if="form.reason.type === 'good'">
          <div style="margin-left: 25px; display: flex; align-items: baseline;">
            <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">ที่มา </span>
            <el-select v-model="form.reason.from" placeholder="เลือกที่มา" @change="changeReasonFrom()" style="margin: 0 24px 14px 0;  max-width: 100px; min-width: 100px;">
              <el-option key="Customer" label="ลูกค้า" value="ลูกค้า"></el-option>
              <el-option key="Other" label="อื่นๆ" value="อื่นๆ"></el-option>
            </el-select>
            <span style="font-size: 18px; font-weight: 400; margin-right: 8px; white-space: nowrap;">สาเหตุ </span>
            <el-select v-if="form.reason.from !== 'อื่นๆ'" v-model="form.reason.reason" placeholder="เลือกสาเหตุ" style="margin: 0 0 14px 0;  width: 100%;">
              <el-option key="Improves" label="คนไข้อาการดีขึ้น" value="คนไข้อาการดีขึ้น"></el-option>
              <el-option key="Dead" label="คนไข้เสียชีวิต" value="คนไข้เสียชีวิต"></el-option>
              <el-option key="ICU" label="คนไข้เข้า ICU" value="คนไข้เข้า ICU"></el-option>
              <el-option key="Hospital" label="คนไข้เข้ารพ.งดเฝ้า" value="คนไข้เข้ารพ.งดเฝ้า"></el-option>
              <el-option key="Behavior" label="พฤติกรรมของคนไข้/ญาติ" value="พฤติกรรมของคนไข้/ญาติ"></el-option>
              <el-option key="Covid" label="คนไข้ตรวจพบโควิด" value="คนไข้ตรวจพบโควิด"></el-option>
              <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
            </el-select>
            <el-select v-if="form.reason.from === 'อื่นๆ'" v-model="form.reason.reason" placeholder="อื่นๆ (โปรดระบุ)" style="margin: 0 0 14px 0;  width: 100%;" disabled>
              <el-option key="Other" label="อื่นๆ (โปรดระบุ)" value="อื่นๆ"></el-option>
            </el-select>
          </div>
        </div>

        <p style="margin-bottom: 0px;"><el-radio label="unknown" style="font-size: 18px;" v-model="form.reason.type" @change="changeReasonType()">Unknown</el-radio></p>

        <el-row style="margin-top: 100px;">
          <el-col :span="4">
            <span style="font-size: 18px; font-weight: 400; white-space: nowrap;">รายละเอียด</span>
          </el-col>
          <el-col :span="18" style="margin-right: 8px;">
            <el-input style="margin-left: 8px;" type="textarea" rows="3" width="65%" v-model="form.reason.detail" @keydown="inputHandler" />
          </el-col>
        </el-row>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleConfirmStatus(false)">ยกเลิก</el-button>
        <el-button type="primary" @click="handleConfirmStatus(true)" class="edit" :disabled="isDisabledChangeStatus">ยืนยัน</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" scope>
    .el-table {
        font-family: 'Sukhumvit';
        font-weight: 300;
    }

    .el-table.table td, .el-table.table th {
        padding: 20px 0;
    }

    .status-container {
        display: flex;
        flex-direction: row;

        .status-item {
          padding: 5px 13px;
          font-family: 'Sukhumvit-SemiBold';
          background: #F1F3F6;
          border-radius: 4px;
          margin-right: 8px;
          display: flex;
          justify-content: center;

          &.usage {
            min-width: 80px;
          }

          &.contract {
            min-width: 150px;
            max-width: 150px;
            padding: 0;
            border: 0;
            display: flex;
            justify-content: center;
            align-items: center;

            .text {
              flex: 3;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .edit-logo {
              flex: 1;
              display: flex;
              justify-content: inherit;
            }

            &:hover {
              opacity: 0.6;
              cursor: pointer;
            }

            &:focus {
              outline: none;
              opacity: 0.8;
            }
          }
        }
    }

    .img-24 {
      margin-bottom: -6px;
      margin-left: 4px;
      outline: none;
    }

    .cg-item:not(:last-child) {
      margin-bottom: 8px;
    }

    .click-row-button {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 32px;
      min-height: 32px;
      border: 1px solid #D5D6DB;
      background: #FFFFFF;
      color: #A2A7B2;
      box-sizing: border-box;
      border-radius: 16px;
      cursor: pointer;

      &:hover {
        border: 1px solid #D5D6DB;
        background: #D5D6DB;
        color: #FFFFFF;
      }

      &:active {
        border: 1px solid #A2A7B2;
        background: #A2A7B2;
        color: #FFFFFF;
      }
    }

    .input-reason-button {
      &:hover {
        opacity: 0.6;
      }

      &:active {
        opacity: 0.85;
      }
    }

    .header-bold-18 {
      font-weight: bold;
      font-size: 18px;
      line-height: 29px;
      color: #434B61;
    }
</style>

<style lang="scss">
  #patient-history-table {
    tr {
      &:hover {
        &>td {
          background: #FFF !important;
        }
      }
    }

    .el-tooltip {
      &:hover {
        cursor: pointer;
      }
    }
  }

  .el-tooltip__popper.is-light {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08);
    border-radius: 9px;
    border-color: #FFFFFF;
    width: 294px;
    min-height: 116px;
    padding: 24px;
    font-family: 'Sukhumvit-SemiBold';
    color: #434B61;
    font-size: 14px;

      .popper__arrow {
        display: none;
      }
  }
</style>
<script>
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'

export default {
  name: 'PatientHistoryTable',
  mixins: [GenericAPIHandler],
  props: {
    list: {
      type: Array,
      required: true,
    },
    getHistoryList: {
      type: Function,
      required: true,
    },
    patientId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      control: {
        showSelectStatusDialog: false,
        showConfirmChangeDialog: false,
      },
      form: {
        id: 0,
        subscribe: null,
        reason: {
          from: '',
          type: '',
          detail: '',
          reason: '',
        },
      },
    }
  },
  computed: {
    isDisabledChangeStatus () {
      switch (this.form.subscribe) {
        case 0:
          return false
        case 1:
          return false
        case 2:
          return this.form.reason.type === ''
        default:
          return true
      }
    },
  },
  methods: {
    rowClick (data) {
      this.$router.push({ name: 'ReservationHistoryLog', params: { id: this.patientId, reservationId: data.reservationID } })
    },
    changeContractHandler (data) {
      this.form.id = data.reservationID
      this.control.showConfirmChangeDialog = true
      if (data.cancel !== null) {
        this.form.reason = { ...data.cancel }
      }
      this.form.subscribe = data.statuses[1] === 'ต่อสัญญา' ? 1 : 2
    },
    handleConfirmChange (status) {
      if (status) {
        this.control.showConfirmChangeDialog = false
        this.control.showSelectStatusDialog = true
      } else {
        this.control.showConfirmChangeDialog = false
        this.form.id = 0
      }
    },
    changeStatus (e) {
      if (this.form.subscribe !== 2) {
        this.form.reason = {
          from: '',
          type: '',
          detail: '',
          reason: '',
        }
      }
    },
    changeReasonFrom () {
      this.form.reason.detail = ''
      this.form.reason.reason = ''
      if (this.form.reason.type === 'good' && this.form.reason.from === 'อื่นๆ') {
        this.form.reason.reason = 'อื่นๆ'
      }
    },
    changeReasonType () {
      this.form.reason.from = ''
      this.form.reason.reason = ''
      this.form.reason.detail = ''
    },
    inputHandler (e) {
      if (e.keyCode === 13 && e.shiftKey) {
        e.preventDefault()
        this.form.reason.detail = `${this.form.reason.detail}\n`
      }
    },
    async handleConfirmStatus (status) {
      if (status) {
        try {
          await this.$api.Reservation.setSubscribe(this.form.id, this.form.subscribe, this.form.reason)
          this.getHistoryList()
        } catch (error) {
          this.showErrorDialog(error)
        }
      }
      this.control.showSelectStatusDialog = false
      this.form = {
        id: 0,
        subscribe: null,
        reason: {
          from: '',
          type: '',
          detail: '',
          reason: '',
        },
      }
    },
  },
}
</script>
